import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator'
import CreateNodeEvent from '@/diagrams/events/create-node-event'
import TopicGroup from '@/diagrams/models/topic-group'
import Match from '@/diagrams/models/match'

@Component
export default class EditTopicGroup extends Vue {

  @Prop({ default: null })
  private parentId!: null | string

  @Prop({ default: false })
  private editMode!: boolean

  @Prop({default: false})
  private archived!: boolean

  private createNode(evt: CreateNodeEvent): TopicGroup {
    const group = new TopicGroup()
    group.projectId = evt.project.id
    return group
  }

  private selectNode(group: TopicGroup, match: Match): TopicGroup {
    group.name = match.name
    if (match.keywords) {
      group.keywords = match.keywords
    }
    return group
  }
}
